import classnames from 'classnames';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';

import styles from './GoodToKnow.module.scss';

const BulletModal = dynamic(
  () =>
    import(
      '@/domains/productDiscovery/ProductPage/common/modules/GoodToKnow/BulletModal'
    ).then((mod) => mod.BulletModal),
  {
    ssr: false,
  },
);

export interface GoodToKnowModalInfoListItemProps {
  icon: React.ReactNode;
  children?: React.ReactNode;
  modalContent?: React.ReactNode;
  modalHeader?: React.ReactNode;
  modalInfo?: string;
}

export const Bullet = ({
  icon,
  children,
  modalContent,
  modalHeader,
  modalInfo,
}: GoodToKnowModalInfoListItemProps) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  if (modalContent !== undefined) {
    return (
      <li>
        <button
          type="button"
          onClick={openModal}
          className={classnames(styles.bullet, styles.button)}
        >
          {icon}
          {children}
        </button>

        {showModal && (
          <BulletModal
            onClose={closeModal}
            modalDescription={modalContent}
            modalHeader={modalHeader || children}
            modalInfo={modalInfo}
          />
        )}
      </li>
    );
  }

  return (
    <li className={styles.bullet}>
      {icon}
      {children}
    </li>
  );
};
